import { render } from "./TheDiaBanThuGomRac.vue?vue&type=template&id=2928fac5"
import script from "./TheDiaBanThuGomRac.vue?vue&type=script&lang=js"
export * from "./TheDiaBanThuGomRac.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__